import React, { useState } from 'react';
import axios from 'axios';
import CircularProgress from '@mui/material/CircularProgress';

const Ekyc_abstract_data_int = () => {
  const [status, setStatus] = useState('');
  const [loadingGenerate, setLoadingGenerate] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [linkGenerated, setLinkGenerated] = useState(false);
  const [hasError, setHasError] = useState(false);

  const handleGenerate = async () => {
    setLoadingGenerate(true);
    setStatus('');
    setLinkGenerated(false);
    setExcelData([]);
    setHasError(false);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL}/api/ekyc-abstract/generate`,
        {},
        { withCredentials: true }
      );

      setStatus(res.data);

      if (res.data && res.data.toLowerCase().includes('download excel')) {
        try {
          const dataRes = await axios.get(
            `${process.env.REACT_APP_URL}/api/ekyc-abstract/excel-data`,
            { withCredentials: true }
          );

          if (dataRes.data && dataRes.data.length > 0) {
            setExcelData(dataRes.data);
            setLinkGenerated(true);
          } else {
            setStatus("Internal Exception");
            setHasError(true);
          }
        } catch (error) {
          console.error('Excel data fetch error:', error);
          setStatus("Internal Exception");
          setHasError(true);
        }
      }
    } catch (error) {
      console.error('Generate error:', error);
      setStatus("Internal Exception");
      setHasError(true);
    }

    setLoadingGenerate(false);
  };

  const downloadExcel = () => {
    if (excelData.length === 0) {
      setStatus("Internal Exception");
      setHasError(true);
      return;
    }

    const titleRow = `
      <tr style="background-color: orange; font-weight: bold; color: black; text-align: center;">
        <td colspan="12">EKYC Abstract</td>
      </tr>
    `;

    const tableHeader = `
      <tr style="background-color: orange; font-weight: bold; color: black; text-align: center;">
        <td rowspan="2">Sl No</td>
        <td rowspan="2">District</td>
        <td rowspan="2">Office</td>
        <td rowspan="2">FPS Id</td>
        <td rowspan="2">Scheme Type</td>
        <td rowspan="2">Scheme</td>
        <td rowspan="2">Total Cards</td>
        <td rowspan="2">Total Units</td>
        <td rowspan="2">EKYC Done Units</td>
        <td colspan="3">Ration Cards</td>
      </tr>
      <tr style="background-color: orange; font-weight: bold; color: black; text-align: center;">
        <td>EKYC Completed</td>
        <td>EKYC Partially Completed</td>
        <td>EKYC Not Done</td>
      </tr>
    `;

    const rows = excelData
      .map(
        (row, index) => `
      <tr>
        <td>${index + 1}</td>
        <td>${row.district || ''}</td>
        <td>${row.office || ''}</td>
        <td style="mso-number-format:'\\@';">${row.fpsId || ''}</td>
        <td>${row.schemeType || ''}</td>
        <td>${row.scheme || ''}</td>
        <td>${row.totalCards || 0}</td>
        <td>${row.totalUnits || 0}</td>
        <td>${row.ekycDoneUnits || 0}</td>
        <td>${row.ekycCompleted || 0}</td>
        <td>${row.ekycPartiallyCompleted || 0}</td>
        <td>${row.ekycNotDone || 0}</td>
      </tr>
    `
      )
      .join('');

    const tot_total_rc = excelData.reduce((sum, r) => sum + (parseInt(r.totalCards) || 0), 0);
    const tot_total_units = excelData.reduce((sum, r) => sum + (parseInt(r.totalUnits) || 0), 0);
    const tot_ekyc_done_units = excelData.reduce((sum, r) => sum + (parseInt(r.ekycDoneUnits) || 0), 0);
    const tot_ekyc_completed = excelData.reduce((sum, r) => sum + (parseInt(r.ekycCompleted) || 0), 0);
    const tot_ekyc_partial = excelData.reduce((sum, r) => sum + (parseInt(r.ekycPartiallyCompleted) || 0), 0);
    const tot_ekyc_not_done = excelData.reduce((sum, r) => sum + (parseInt(r.ekycNotDone) || 0), 0);

    const totalRow = `
      <tr style="background-color: orange; font-weight: bold; color: black; text-align: center;">
        <td colspan="6">Total</td>
        <td>${tot_total_rc}</td>
        <td>${tot_total_units}</td>
        <td>${tot_ekyc_done_units}</td>
        <td>${tot_ekyc_completed}</td>
        <td>${tot_ekyc_partial}</td>
        <td>${tot_ekyc_not_done}</td>
      </tr>
    `;

    const dataTimeRow = `
      <tr style="background-color: orange; font-weight: bold; color: black; text-align: right;">
        <td colspan="12">Data Time: ${new Date().toLocaleString()}</td>
      </tr>
    `;

    const tableHtml = `
      <table border="1">
        <thead>
          ${titleRow}
          ${tableHeader}
        </thead>
        <tbody>
          ${rows}
          ${totalRow}
          ${dataTimeRow}
        </tbody>
      </table>
    `;

    const blob = new Blob([tableHtml], { type: 'application/vnd.ms-excel' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'EKYC_Abstract.xls';
    a.click();
  };

  return (
    <form>
      <table width="35%" align="center" style={{marginTop:"15px"}}>
        <tbody>
          <tr className="tableheader">
            <td colSpan="2" align="center">EKYC Abstract</td>
          </tr>

          <tr>
            <td colSpan="2" align="center">
              <button
                type="button"
                className="button button2"
                onClick={handleGenerate}
                disabled={loadingGenerate}
              >
                Generate EKYC Abstract
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      {loadingGenerate && (
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <CircularProgress/>
        </div>
      )}

      {status && (
        <div
          align="center"
          style={{
            margin: '20px',
            fontWeight: 'bold',
            color: hasError ? 'brown' : 'brown',
            textDecoration: 'underline',
            fontSize: hasError ? '18px' : 'inherit'
          }}
        >
          {status}
        </div>
      )}

      {linkGenerated && !hasError && (
        <div align="center" style={{ marginTop: '35px' }}>
          <a
            href="#"
            onClick={e => {
              e.preventDefault();
              downloadExcel();
            }}
            style={{ fontWeight: 'bold', color: 'blue', textDecoration: 'underline' }}
          >
            Download EKYC Abstract Excel
          </a>
        </div>
      )}
    </form>
  );
};

export default Ekyc_abstract_data_int;